<template><!-- svgo-optimised -->
<svg class="icon icon__arrow icon__arrow--carousel-previous-button" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><path d="M24 12.001H2.914l5.294-5.295-.707-.707L1 12.501l6.5 6.5.707-.707-5.293-5.293H24v-1z" data-name="Left"/></svg>
</template>